export default [
    {
        path: 'unificacao-usuario-paciente',
        component: () => import(/* webpackChunkName: 'unificacao-usuario-paciente' */'@/views/cadastro/unificacao-usuario-paciente/Index'),
        redirect: 'unificacao-usuario-paciente/index',
        children: [
            {
                name: 'cadastro-unificacao-usuario-paciente-index',
                path: 'index',
                component: () => import(/* wecadastrockChunkName: 'unificacao-usuario-paciente' */ '@/views/cadastro/unificacao-usuario-paciente/Form.vue'),
            },
        ],
    },
]